<template>
   <v-container fluid>
        <div v-if="!loading">
            <v-row 
                class="my-2 subtitle-2 secondary--text pl-12">
                Information about the team
            </v-row>
            <v-divider />
            <!--table head-->
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    class="tabCell"
                    :class="item.style">
                    {{ item.title }}
                </v-col>
            </v-row>
    
            <div v-if="teams.length">
                <!--teams tab-->
                <v-row v-for="team in teams" :key="team.id" no-gutters> 
                    <v-col class="tabCell text-left">{{ team.gameId }}</v-col>
                    <v-col class="tabCell text-center">{{ team.game.category }}</v-col>
                    <v-col class="tabCell text-center">{{ team.id }}</v-col>
                    <v-col class="tabCell text-center">{{ team.name }}</v-col>
                    <v-col class="tabCell text-right">
                        <edit-team :team="team" />
                        <delete-team :team="team" />
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>
<script>
import deleteTeam from '../../../components/admin/teams/deleteTeam.vue';
import editTeam from '../../../components/admin/teams/editTeam.vue';
export default {
    data() {
        return {
            headers: [
                { title: 'Game id', style: 'text-left', cols: 1 },
                { title: 'Game category', style: 'text-center', cols: 1 },
                { title: 'Team id', style: 'text-center', cols: 1 },
                { title: 'Team name', style: 'text-center', cols: 2 },
                { title: 'Actions', style: 'text-right', cols: 1 },     
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        teams() {
            /* console.log(this.$store.getters.teams) */
            return this.$store.getters.teams
        }
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        }
    },
    components: {
        deleteTeam, editTeam
    }
}
</script>